import { Clock, Mail, Phone, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Logo";
import { BUSINESS } from "@/constants/business";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="border-t border-[#22262F] bg-[#060709] overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 pt-20 pb-10">
                <div className="grid md:grid-cols-3 gap-12 pb-16">
                    <div>
                        <div className="flex items-center gap-3 mb-5">
                            <Logo />
                            <span className="font-display font-extrabold text-lg uppercase text-white">
                                Masons Automotive
                            </span>
                        </div>
                        <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
                            Precision master mechanics brought direct to your location. {BUSINESS.location}.
                        </p>
                    </div>
                    <div>
                        <div className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400 mb-5">Dispatch</div>
                        <a
                            href={BUSINESS.phoneTel}
                            data-testid="footer-call-link"
                            className="flex items-center gap-3 text-zinc-300 hover:text-amber-400 transition-colors duration-200 text-sm mb-3"
                        >
                            <Phone className="w-4 h-4 text-amber-500" /> {BUSINESS.phoneDisplay}
                        </a>
                        <a
                            href={`mailto:${BUSINESS.email}`}
                            data-testid="footer-email-link"
                            className="flex items-center gap-3 text-zinc-300 hover:text-amber-400 transition-colors duration-200 text-sm mb-3"
                        >
                            <Mail className="w-4 h-4 text-amber-500" /> {BUSINESS.email}
                        </a>
                        <div className="flex items-center gap-3 text-zinc-500 text-sm">
                            <Clock className="w-4 h-4 text-amber-500" /> {BUSINESS.hours}
                        </div>
                    </div>
                    <div>
                        <div className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400 mb-5">Navigate</div>
                        <div className="flex flex-col gap-3 text-sm">
                            {[
                                ["Services", "/#services"],
                                ["How It Works", "/#how-it-works"],
                                ["Coverage", "/#coverage"],
                                ["Book a Mechanic", "/#booking"],
                                ["Track Booking", "/track"],
                                ["Staff Portal", "/admin"],
                            ].map(([label, href]) => (
                                <a
                                    key={label}
                                    href={href}
                                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="text-zinc-400 hover:text-amber-400 transition-colors duration-200"
                                >
                                    {label}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                <div
                    data-testid="footer-wordmark"
                    className="font-display font-extrabold uppercase leading-none text-outline select-none whitespace-nowrap text-[13vw] tracking-tight"
                    aria-hidden="true"
                >
                    Masons Auto
                </div>

                <div className="mt-10 pt-8 border-t border-[#22262F] flex flex-wrap items-center justify-between gap-4">
                    <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-600">
                        © 2026 Masons Automotive · {BUSINESS.location}
                    </span>
                    <span className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-600">
                        <ShieldCheck className="w-3.5 h-3.5 text-amber-500" /> 24-Month / 30,000-KM Warranty
                    </span>
                </div>
            </div>
        </footer>
    );
}
